import { useContext } from "react";

import Context from "./PlaceMarkContext";

const usePlaceMarkContext = () => useContext(Context);

export default usePlaceMarkContext;
